import React, { createContext, useContext, useEffect, useState } from 'react';
import { api, setToken, getToken } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (getToken()) {
        try { setUser(await api.get('/auth/me')); }
        catch { setToken(null); }
      }
      setLoading(false);
    })();
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    setToken(res.token);
    setUser(res.user);
    return res.user;
  };
  const logout = () => { setToken(null); setUser(null); window.location.href = '/login'; };
  const refresh = async () => { try { setUser(await api.get('/auth/me')); } catch {} };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
